import { memo } from 'react';

import PendingReviewIconSVG from '@/assets/pending-review-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IPendingReviewIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={PendingReviewIconSVG} {...props} />
);

export const PendingReviewIcon = memo(IPendingReviewIcon) as typeof IPendingReviewIcon;
